import { SurveyStorageKeys, surveyStorage } from '@plugins/storage'
import { Choice, Graphic, Meta, QuestionType, SubTacticalQuestion, TacticalQuestion } from './Survey/Survey'
import { SurveyState } from '@reducers/SurveyReducer'

export interface TacticalEntry {
  value: string
  reference: string
}

export class TacticalQuestionClass implements TacticalQuestion {
  choices: Choice[]
  meta: Meta & { tacticalReference?: string; subQuestions?: SubTacticalQuestion[] }
  active: boolean
  staticGraphics?: Graphic[]
  defaultGraphics?: Graphic[]
  label?: string
  hint?: string
  id: string
  key: string
  optional: boolean
  order: number
  text: string
  type: QuestionType
  notInResults?: boolean

  constructor(question: TacticalQuestion) {
    this.choices = question.choices
    this.meta = question.meta
    this.active = question.active
    this.staticGraphics = question.staticGraphics
    this.defaultGraphics = question.defaultGraphics
    this.label = question.label
    this.hint = question.hint
    this.id = question.id
    this.key = question.key
    this.optional = question.optional
    this.order = question.order
    this.text = question.text
    this.type = question.type
    this.notInResults = question.notInResults
  }

  get reference(): string | undefined {
    return this.meta.tacticalReference
  }

  get subQuestions(): SubTacticalQuestion[] | undefined {
    return this.meta.subQuestions
  }

  chosenQuestion() {
    return this.meta.subQuestions
  }

  hasBeenChosenAlready(surveyState: SurveyState) {
    const ids = this.meta.subQuestions?.map((s) => s.id)
    return surveyState?.questionIds.find((id) => ids?.includes(id))
  }

  getRandomSubQuestionByProbability() {
    if (!this.subQuestions?.length) {
      return null
    }

    const questions = this.subQuestions

    const totalPercentage = questions.reduce((total, question) => total + question.probability, 0)
    const normalizedProbabilities = questions.map((question) => question.probability / totalPercentage)

    const cumulativeProbabilities = normalizedProbabilities.map((_, i) =>
      normalizedProbabilities.slice(0, i + 1).reduce((sum, prob) => sum + prob, 0),
    )

    const scaledRandomNumber = Math.random() * cumulativeProbabilities[cumulativeProbabilities.length - 1]

    for (let i = 0; i < cumulativeProbabilities.length; i++) {
      if (scaledRandomNumber <= cumulativeProbabilities[i]) {
        return questions[i]
      }
    }

    return questions[0]
  }
}
